import * as Yup from 'yup';

import { UnknownOption } from '@savgroup-front-common/types';

import messages from './messages';

const claimGroupReasonSchema = () => {
  return Yup.object().shape({
    reason: Yup.object()
      .nullable()
      .test(
        'required-reason',
        messages.reasonIsRequired,
        function validateRequiredReason(option: UnknownOption) {
          if (!option) {
            return false;
          }

          return option.value !== null && option.value !== undefined;
        },
      )
      .required(messages.reasonIsRequired),
  });
};

export default claimGroupReasonSchema;
